// sagas/rootSaga.js

import { all, fork } from 'redux-saga/effects';
import authSaga, {
    watchReAuthenticate, watchRefreshToken, watchRegister, watchResetPassword, watchSetNewPassword,
    watchSocialMediaLogin, watchLogoutSaga, watchPartners, authQueueWatcher
} from '../sagas/authSaga'; // Import auth sagas
import { watchTokenExpiration } from '../sagas/watchTokenExpiration'; // Import token expiration saga
import { watchPaginatedData } from './partnerSaga';

export default function* rootSaga() {
    yield all([
        fork(authSaga),              // login + 2FA
        fork(authQueueWatcher),      // owns REFRESH_TOKEN_REQUEST + LOGOUT_REQUEST
        fork(watchTokenExpiration),  // while(true) expiry loop
        fork(watchReAuthenticate),
        fork(watchRegister),
        fork(watchResetPassword),
        fork(watchSetNewPassword),
        fork(watchSocialMediaLogin),
        fork(watchPartners),
        fork(watchPaginatedData)
        // Add more sagas if needed
    ]);
}
